import React, { memo } from 'react';
import styled from 'styled-components';
import { Divider as PCLNDivider } from 'pcln-design-system';
const StyledDivider = /*#__PURE__*/styled(PCLNDivider).withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-1kzr704-0"
})(["z-index:1;"]);
function Divider() {
  return React.createElement(StyledDivider, {
    borderColor: 'background.light',
    my: 0
  });
}
export default memo(Divider);